import PageContainer from "../../../components/PageContainer";
import ConfigButton from "../../../components/ConfigButton";
import SettingsFunctions from "./SettingsFunctions"; 
import { MdCached, MdSchedule, MdRefresh, MdEmail, MdHistory } from "react-icons/md";
import { TbReportAnalytics } from "react-icons/tb";
import ModalLoading from "../../../components/ModalLoading";
import CustomModal from "../../../components/CustomModal";
import useProcessingStatus from "./useProcessingStatus";
import { RelatoriosCreateStatus } from "../../../util/enum";
import { useAuth } from "../../../context/AuthContext";

const ControlMainPage = () => {
  const { user } = useAuth();
  const { cleanCahce, loading: cacheLoading } = SettingsFunctions.useCacheManager();
  const { relatoriosTurnoverHistoricoCapacidade, processing, processingMessage } = SettingsFunctions.useRelatorioTurnoverHistoricoCapacidade();
  const { iniciarFechamento, statusMessage, loading: fechamentoLoading } = SettingsFunctions.useFechamentoAutomatico();
  const { recalcularHistoricoCapacidade, loading: recalculoLoading, statusMessage: recalculoStatus } = SettingsFunctions.useRecalculoHistoricoCapacidade();
  const { enviarNotificacaoPonto, enviarNotificacaoPontoMesAnterior, loading: notificacaoLoading, loadingMesAnterior: notificacaoMesAnteriorLoading } = SettingsFunctions.useNotificacaoPonto();
  const { salvarApuracaoHorasExtrasRetroativo, loading: horasExtrasRetroativoLoading } = SettingsFunctions.useSalvarApuracaoHorasExtrasRetroativo();
  const { iniciarApuracaoHoraExtra, loading: apuracaoHoraExtraLoading } = SettingsFunctions.useApuracaoHoraExtra();
  const { calcularBancoDeHorasRetroativo, loading: bancoHorasRetroativoLoading } = SettingsFunctions.useCalcularBancoDeHorasRetroativo();
  
  // Verificar roles do Keycloak
  const resource_access = user?.roles['convert-api'] ? user?.roles['convert-api']['roles'] : [];
  const hasRotinaRole = resource_access.includes("rotina");
  const hasRecalculoRole = resource_access.includes("recalculo-historico-capacidade");
  const hasSalvarApuracaoHorasRetroativasRole = resource_access.includes("salvar-apuracao-horas-retroativas");
  const hasCalcularBancoHorasRetroativoRole = resource_access.includes("salvar-apuracao-horas-retroativas");
  
  console.log("processing === RelatoriosCreateStatus.IN_PROGRESS", processing === RelatoriosCreateStatus.IN_PROGRESS);

  const handleCleanCache = () => {
    const label = "Essa ação irá limpar todo o cache do Convert. Tem certeza que deseja continuar?";
    SettingsFunctions.openConfirmationModal(cleanCahce, label);
  };

  const handleRelatoriosTurnoverHistoricoCapacidade = () => {
    const label = "Essa ação irá criar relatórios de Turnover e Histórico da Capacidade da Área do periodo do primeiro fechamento até o ultimo e poderá demorar alguns minutos. Tem certeza que deseja continuar?";
    SettingsFunctions.openConfirmationModal(relatoriosTurnoverHistoricoCapacidade, label);
  };

  const handleFechamentoAutomatico = () => {
    SettingsFunctions.openDiaUtilSelectionModal((diaUtil) => {
      const label = `Essa ação irá iniciar o fechamento para o ${diaUtil}º dia útil do mês atual. Tem certeza que deseja continuar?`;
      const action = () => {
        iniciarFechamento(diaUtil);
      };
      SettingsFunctions.openConfirmationModal(action, label);
    });
  };

  const handleRecalculoHistoricoCapacidade = () => {
    SettingsFunctions.openMesAnoSelectionModal((data) => {
      recalcularHistoricoCapacidade(data);
    });
  };

  const handleNotificacaoPonto = () => {
    const label = "Essa ação irá enviar e-mails de notificação sobre divergência de horas (PontoTwo x Jira) para o mês atual. Tem certeza que deseja continuar?";
    SettingsFunctions.openConfirmationModal(enviarNotificacaoPonto, label);
  };

  const handleNotificacaoPontoMesAnterior = () => {
    const label = "Essa ação irá enviar e-mails de notificação sobre divergência de horas (PontoTwo x Jira) para o mês anterior. Tem certeza que deseja continuar?";
    SettingsFunctions.openConfirmationModal(enviarNotificacaoPontoMesAnterior, label);
  };

  const handleSalvarApuracaoHorasExtrasRetroativo = () => {
    const label = "Essa ação irá salvar a apuração de horas extras retroativas. Tem certeza que deseja continuar?";
    SettingsFunctions.openConfirmationModal(salvarApuracaoHorasExtrasRetroativo, label);
  };

  const handleCalcularBancoDeHorasRetroativo = () => {
    const label = "Essa ação irá calcular o banco de horas retroativos. Tem certeza que deseja continuar?";
    SettingsFunctions.openConfirmationModal(calcularBancoDeHorasRetroativo, label);
  };

  const handleApuracaoHoraExtra = () => {
    const label = "Essa ação irá iniciar manualmente a apuração de horas extras. Tem certeza que deseja continuar?";
    SettingsFunctions.openConfirmationModal(iniciarApuracaoHoraExtra, label);
  };

  const loading = cacheLoading || fechamentoLoading;
  
  return (
    <PageContainer title="Painel de Controle">
      {loading && <ModalLoading />}
      <div className="d-flex flex-wrap justify-content-start align-items-center">
        <ConfigButton
          action={handleCleanCache}
          disable={loading}
          icon={<MdCached size={60} />}
          label="Limpar Cache"
          fontLabelSize={"16px"}
          helpKey="limpar-cache"
          helpLabel="Limpa o cache dos serviços do Convert"
        />
        <ConfigButton
          action={handleRelatoriosTurnoverHistoricoCapacidade}
          disable={processing === RelatoriosCreateStatus.IN_PROGRESS}
          icon={<TbReportAnalytics size={60} />}
          label="Criar relatórios Turnover e Histórico de capacidade da área"
          fontLabelSize={"12px"}
          helpKey="relatorios-turnover-historico-area"
          helpLabel="Cria relatórios Turnover e Histórico de capacidade da área"
          status={processingMessage}
        />
        {hasRotinaRole && (
          <ConfigButton
            action={handleFechamentoAutomatico}
            disable={loading}
            icon={<MdSchedule size={60} />}
            label="Executar Rotina de Fechamento"
            fontLabelSize={"14px"}
            helpKey="fechamento-automatico"
            helpLabel="Inicia o fechamento para o mês atual"
            status={statusMessage}
          />
        )}
        {hasRecalculoRole && (
          <ConfigButton
            action={handleRecalculoHistoricoCapacidade}
            disable={recalculoLoading}
            icon={<MdRefresh size={60} />}
            label="Recalcular Histórico de Capacidade"
            fontLabelSize={"13px"}
            helpKey="recalculo-historico-capacidade"
            helpLabel="Recalcula o histórico de capacidade para um mês específico"
            status={recalculoStatus}
          />
        )}
        {hasRotinaRole && (
          <ConfigButton
            action={handleNotificacaoPonto}
            disable={notificacaoLoading}
            icon={<MdEmail size={60} />}
            label="Divergência de Horas (Mês Atual)"
            fontLabelSize={"13px"}
            helpKey="notificacao-ponto"
            helpLabel="Envia e-mail de divergência de horas PontoTwo x Jira para o mês atual"
          />
        )}
        {hasRotinaRole && (
          <ConfigButton
            action={handleNotificacaoPontoMesAnterior}
            disable={notificacaoMesAnteriorLoading}
            icon={<MdEmail size={60} />}
            label="Divergência de Horas (Mês Anterior)"
            fontLabelSize={"13px"}
            helpKey="notificacao-ponto-mes-anterior"
            helpLabel="Envia e-mail de divergência de horas PontoTwo x Jira para o mês anterior"
          />
        )}
        {hasRotinaRole && (
          <ConfigButton
            action={handleApuracaoHoraExtra}
            disable={apuracaoHoraExtraLoading}
            icon={<MdHistory size={60} />}
            label="Iniciar Apuração de Horas Extras"
            fontLabelSize={"13px"}
            helpKey="apuracao-horas-extras-manual"
            helpLabel="Inicia manualmente a apuração de horas extras"
          />
        )}
        {hasSalvarApuracaoHorasRetroativasRole && (
          <ConfigButton
            action={handleSalvarApuracaoHorasExtrasRetroativo}
            disable={horasExtrasRetroativoLoading}
            icon={<MdHistory size={60} />}
            label="Salvar Apuração de Horas Extras Retroativas"
            fontLabelSize={"13px"}
            helpKey="salvar-apuracao-horas-extras-retroativas"
            helpLabel="Salva a apuração de horas extras retroativas no PontoTwo"
          />
        )}
        {hasCalcularBancoHorasRetroativoRole && (
          <ConfigButton
            action={handleCalcularBancoDeHorasRetroativo}
            disable={bancoHorasRetroativoLoading}
            icon={<MdHistory size={60} />}
            label="Calcular Banco de Horas Retroativos"
            fontLabelSize={"13px"}
            helpKey="calcular-banco-horas-retroativos"
            helpLabel="Calcula o banco de horas retroativos no PontoTwo"
          />
        )}
      </div>
      <CustomModal />
    </PageContainer>
  );
};

export default ControlMainPage;
